import apiServices from "utils/axios";

export const fetchConnections = async () => {
  const { data } = await apiServices.get("/connections");
  return data;
};

export const connectAutodesk = async () => {
  const { data } = await apiServices.get("aps/connection/create");
  return data;
};

export const connectGoogleDrive = async (code) => {
  const payload = {
    code,
    user_id: 1,
  };

  const { data } = await apiServices.post(
    "/gdrive/connection/create",
    payload
  );

  return data;
};

export const connectRedas = async ({username, password, project_id}) => {
  const payload = { username, password, project_id }

  const { data } = await apiServices.post(
    "/redas/connection/create",
    payload
  );

  return data;
};

export const connectSgbuildex = async (payload) => {
  // const payload = { pitstop, access_token:accesstoken }

  const { data } = await apiServices.post(
    "/sgbuildex/connection/create",
    payload
  );

  return data;
};


export const deleteConnection = async (id) => {
  const { data } = await apiServices.delete(`/connections/${id}`);
  return data;
};
